module.exports = __webpack_public_path__ + "static/media/eye-close_dark.ac74e170.svg";